/**
 * Veřejné rozhraní katalogu her.
 *
 * Aplikace nikdy neimportuje konkrétní hru — pracuje jen s tímto modulem.
 * Díky tomu se přidáním adresáře do `src/` objeví nová hra všude,
 * kde se katalog používá.
 */
export type {
  BoolParamDef,
  EnumParamDef,
  GameCategory,
  GameComponent,
  GameConfig,
  GameManifest,
  GameModule,
  GameProps,
  GameResult,
  MetricDef,
  NumberParamDef,
  ParamDef,
  TrialRecord,
} from './types.ts'

export { defaultConfig, resolveConfig } from './types.ts'
export { components, manifests } from './registry.ts'

import type { GameComponent, GameManifest } from './types.ts'
import { components, manifests } from './registry.ts'

/** Manifest hry, nebo `undefined`, pokud hra už v katalogu není. */
export function getManifest(id: string): GameManifest | undefined {
  return manifests.find((m) => m.id === id)
}

/** Komponenta hry — líně načítaná, patří dovnitř `<Suspense>`. */
export function getComponent(id: string): GameComponent | undefined {
  return components[id]
}

/** Existuje hra s tímto `id`? Programy uložené v databázi mohou odkazovat na starší. */
export function gameExists(id: string): boolean {
  return manifests.some((m) => m.id === id)
}
